import { RowCrudStatus } from "../../common/types";
import {
  ShowcaseCategory,
  ShowcaseCategoryCreateMutationVariables,
  ShowcaseCategoryUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type ShowcaseCategoryValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  code: string;
  name: string;
};

export type ShowcaseCategoryErrorsType = {
  code?: { message: string; fieldLabel: string };
  name?: { message: string; fieldLabel: string };
};

export function ShowcaseCategoryValuesInit(): ShowcaseCategoryValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    code: "",
    name: "",
  };
}

export type ShowcaseCategoryType =
  | ShowcaseCategory
  | ShowcaseCategoryValuesType;

export function showcaseCategoryDisplayId(
  source: Partial<ShowcaseCategory>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getShowcaseCategoryValues(
  source: ShowcaseCategoryType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ShowcaseCategoryValuesType {
  const entityValues = ShowcaseCategoryValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : showcaseCategoryDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.code = source.code;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getShowcaseCategoryUpdateVariables(
  values: ShowcaseCategoryValuesType
): ShowcaseCategoryUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    code: values.code,
    name: values.name,
  };
}

export function getShowcaseCategoryCreateVariables(
  values: ShowcaseCategoryValuesType
): ShowcaseCategoryCreateMutationVariables {
  return {
    code: values.code,
    name: values.name,
  };
}
